import type { NavigationCageStatus, NavigationMatch } from './types';

const CAGE_STATUSES: readonly NavigationCageStatus[] = ['active', 'inactive', 'historical'];

function isRecord(value: unknown): value is Record<string, unknown> {
    return value != null && typeof value === 'object' && !Array.isArray(value);
}

function isCageStatus(value: unknown): value is NavigationCageStatus {
    return typeof value === 'string' && CAGE_STATUSES.some((status) => status === value);
}

function asOptionalString(value: unknown): string | undefined {
    return typeof value === 'string' && value.length > 0 ? value : undefined;
}

function asOptionalNumber(value: unknown): number | undefined {
    return typeof value === 'number' && Number.isFinite(value) ? value : undefined;
}

function asOptionalStatus(value: unknown): NavigationCageStatus | undefined {
    return isCageStatus(value) ? value : undefined;
}

function mapMatch(raw: unknown): NavigationMatch | null {
    if (!isRecord(raw)) {
        return null;
    }
    if (raw.kind !== 'cage' && raw.kind !== 'bioscope' && raw.kind !== 'winch') {
        return null;
    }
    if (typeof raw.id !== 'number' || !Number.isFinite(raw.id)) {
        return null;
    }
    return {
        kind: raw.kind,
        id: raw.id,
        name: asOptionalString(raw.name),
        clientId: asOptionalNumber(raw.clientId),
        clientName: asOptionalString(raw.clientName),
        locationId: asOptionalNumber(raw.locationId),
        locationName: asOptionalString(raw.locationName),
        cageId: asOptionalNumber(raw.cageId),
        cageName: asOptionalString(raw.cageName),
        bioscopeId: asOptionalNumber(raw.bioscopeId),
        status: asOptionalStatus(raw.status),
    };
}

export function mapNavigationResolveToDomain(response: unknown): NavigationMatch[] {
    if (!isRecord(response) || !Array.isArray(response.matches) || response.matches.length === 0) {
        return [];
    }
    return response.matches
        .map(mapMatch)
        .filter((match): match is NavigationMatch => match != null);
}
